import { useEffect, RefObject } from 'react';

type RefType = RefObject<HTMLElement>;

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideClick = (ref: RefType, callback: () => void): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

export default useOutsideClick;
